import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { LocationService } from '../proxy/planning/controllers/location.service';
import { CostCenterService } from '@controlling/proxy/controlling/controllers/cost-center.service';
import { SapDocumentTypeService } from '@controlling/proxy/controlling/controllers/sap-document-type.service';
FieldBuilder.setNamespace('Planning');

export const COSTCENTERBYLOCATION_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('locationId', 'Entity.Location', LocationService)
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('costCenterId', 'Entity.CostCenterByLocation.CostCenter', CostCenterService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('sapDocumentTypeId', 'Entity.CostCenterByLocation.SapDocumentType', SapDocumentTypeService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const COSTCENTERBYLOCATION_CONFIG = {
  entityName: 'CostCenterByLocation',
  localizationKey: 'Planning::Entity.CostCenterByLocation',
  fields: COSTCENTERBYLOCATION_FIELDS,
  permission: 'ControllingLiquidations.CostCenterByLocations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
